// extracted by mini-css-extract-plugin
export default {"navbar":"PageShell_navbar__QLYlr","navbarMain":"PageShell_navbarMain__HW24m","link":"PageShell_link__8GdSx"};